import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import RadioButton from "../../../../../../../components/radiobutton/RadioButton";
import Input from "../../../../../../../components/textbox/Input";
import styles from "../../../../InfoCliniche/InfoCliniche.module.css";
import stylesArbo from "../SchedaSpecialeArbovirosi.module.css";
import Utils from "../../../../../../../utils/Utils";

class classificazioneDelCaso extends Component {

    state = {
        ClassificazioneDelCaso: {
            caso: "",
            classificazione: "",
            casoWestNile: "",
            note: "",
            corretto: []
        }
    }

    constructor(props) {
        super(props);
        this.riceviValore = this.riceviValore.bind(this);
        this.controlloCorrettezza = this.controlloCorrettezza.bind(this);
        this.createOggettoBE = this.createOggettoBE.bind(this);
        this.calcolaWestNile = this.calcolaWestNile.bind(this);
        this.isWestNileAbilitato = this.isWestNileAbilitato.bind(this);
    }

    // West Nile è abilitato per 0664 sempre;
    // per 064 solo se listaDettaglioLab contiene un codice Usutu
    isWestNileAbilitato() {
        if (this.props.malattiacodice === "0664") return true;
        if (this.props.malattiacodice === "064") {
            const usutuCodes = ["338", "336", "337", "335", "333", "334", "339", "331", "340"];
            const listaRaw =
                this.props.segnalazioneCopia?.listaDettaglioLab ??
                this.props.segnalazioneCopia?.infoLaboratorio?.listaDettaglioLab;
            if (!listaRaw) return false;
            const lista = Array.isArray(listaRaw) ? listaRaw : [listaRaw];
            return lista.some(item => {
                const codice = String(item?.codiceInfoLaboratorio ?? item ?? "").trim();
                return usutuCodes.includes(codice);
            });
        }
        return false;
    }

    componentDidMount() {
        const statoMap = { "01": "POSSIBILE", "02": "PROBABILE", "03": "CONFERMATO" };
        const classificazioneDaStato = statoMap[this.props.segnalazioneCopia?.statoSegnalazione];

        const datiSalvati = this.props.segnalazioneCopia?.schedaSpeciale?.classificazioneDelCaso
            ? JSON.parse(JSON.stringify(this.props.segnalazioneCopia.schedaSpeciale.classificazioneDelCaso))
            : {};

        const westNileAbilitato = this.isWestNileAbilitato();
        const infoCliniche = this.props.segnalazioneCopia?.schedaSpeciale?.informazioniCliniche;
        const infoGenerali = this.props.segnalazioneCopia?.schedaSpeciale?.informazioniGenerali;
        const casoWestNileCalcolato = westNileAbilitato ? this.calcolaWestNile(infoCliniche, infoGenerali) : "";

        this.setState({
            ClassificazioneDelCaso: {
                ...this.state.ClassificazioneDelCaso,
                ...datiSalvati,
                classificazione: classificazioneDaStato || "",
                ...(casoWestNileCalcolato ? { casoWestNile: casoWestNileCalcolato } : {}),
                corretto: []
            }
        }, () => this.aggiornaPadre());
    }

    calcolaWestNile(infoCliniche, infoGenerali) {
        const P1 = ["Encefalite", "Meningite", "Poliradicoloneurite", "Paralisi Flaccida Acuta", "Altri Sintomi Neurologici"];
        const P3_LABELS = ["Astenia/Cefalea", "Artralgia", "Poliartralgia Grave", "Mialgia", "Rush/Esantema",
                           "Nausea Vomito", "Dolore Orbitale Retro Orbitale", "Congiuntivite", "Febbre Emorragica",
                           "Altri Sintomi Non Neurologici"];

        const presenzaSintomi     = infoCliniche?.presenzaSintomi;
        const febbre              = infoCliniche?.febbre;
        const manifestazioni      = infoCliniche?.manifestazioniCliniche || [];
        const condizioniRischio   = infoCliniche?.condizioniRischioPreesistenti;
        const donatore            = infoGenerali?.donatore;

        // Presenza Sintomi = NO: cortocircuito diretto su Donatore / Asintomatico
        if (presenzaSintomi === "02") {
            return donatore === "01" ? "DONATORE" : "ASINTOMATICO";
        }

        const hasP1 = manifestazioni.some(lbl => P1.includes(lbl));
        const hasP2 = febbre === "01";
        const hasP3 = manifestazioni.some(lbl => P3_LABELS.includes(lbl)) || condizioniRischio === "01";

        if (hasP1) return "NEUROINVASIVA";
        if (hasP2) return "FEBBRE";
        if (hasP3) return "SINTOMATICO";

        return "";
    }

    componentDidUpdate(prevProps) {
        const westNileAbilitato = this.isWestNileAbilitato();
        if (!westNileAbilitato) return;

        const prevC = prevProps.informazioniCliniche || {};
        const currC = this.props.informazioniCliniche || {};
        const currG = this.props.informazioniGenerali  || {};

        const clinicheChanged =
            prevC.presenzaSintomi               !== currC.presenzaSintomi              ||
            prevC.febbre                        !== currC.febbre                       ||
            prevC.condizioniRischioPreesistenti !== currC.condizioniRischioPreesistenti ||
            JSON.stringify(prevC.manifestazioniCliniche) !== JSON.stringify(currC.manifestazioniCliniche);

        const generaliChanged = prevProps.donatore !== this.props.donatore;

        if (clinicheChanged || generaliChanged) {
            const calcolato = this.calcolaWestNile(currC, currG);
            if (calcolato !== this.state.ClassificazioneDelCaso.casoWestNile) {
                this.setState(prevState => ({
                    ClassificazioneDelCaso: {
                        ...prevState.ClassificazioneDelCaso,
                        casoWestNile: calcolato
                    }
                }), () => this.aggiornaPadre());
            }
        }
    }

    riceviValore(arg1, arg2) {
        let classificazione = this.state.ClassificazioneDelCaso;
        let field, valore;

        // Logica robusta copiata dal tuo esempio
        if (typeof arg1 === "string" && arg2 && arg2.target) {
            field = arg1;
            valore = arg2.target.value;
        } else if (arg1 && arg1.target) {
            field = arg1.target.id || arg1.target.name;
            valore = arg1.target.value;
        }

        if (field) {
            classificazione[field] = valore;

            // Business Rule: Reset specifica West Nile se non è importato (se necessario)
            if (field === "caso" && valore !== "03") {
                // classificazione.casoWestNile = ""; 
            }

            this.setState({ClassificazioneDelCaso: classificazione}, () => {
                this.aggiornaPadre();
            });
        }
    }

    aggiornaPadre() {
        this.controlloCorrettezza();
        if (this.props.controlloCorrettezza) this.props.controlloCorrettezza();
        
        let oggettoBE = this.createOggettoBE();
        if(this.props.setClassificazioneDelCaso) {
            this.props.setClassificazioneDelCaso(this.state.ClassificazioneDelCaso, oggettoBE);
        }
    }

    controlloCorrettezza() {
        let dati = this.state.ClassificazioneDelCaso;
        dati.corretto = [];

        if (!dati.caso) dati.corretto[0] = "Campo Caso obbligatorio";
        if (!dati.classificazione) dati.corretto[1] = "Campo Classificazione obbligatorio";

        const westNileAbilitato = this.isWestNileAbilitato();
        if (!westNileAbilitato) {
            dati.casoWestNile = "";
        } else if (!dati.casoWestNile) {
            dati.corretto[2] = "Specifica il tipo di caso (Neuroinvasiva/Febbre/etc.)";
        }
    }

    createOggettoBE() {
        let copiaDati = JSON.parse(JSON.stringify(this.state.ClassificazioneDelCaso));
        let pulito = Utils.removeEmptyValueFromObject(copiaDati);
        return Utils.removeFieldFromObject(pulito, "corretto");
    }

    render() {
        const {t} = this.props;
        const {ClassificazioneDelCaso: data} = this.state;
        const path = "SchedaSpecialeArbovirosi.ClassificazioneDelCaso";

        // Definizione degli array per mappare i radiobutton
        const opzioniCaso = [
            { id: "caso01", val: "AUTOCTONO, stessa Regione", label: `${path}.opzioniCaso.autoctono_stessa` },
            { id: "caso02", val: "AUTOCTONO, proveniente da altra Regione", label: `${path}.opzioniCaso.autoctono_altra` },
            { id: "caso03", val: "IMPORTATO, da stato Estero", label: `${path}.opzioniCaso.importato` }
        ];

        const opzioniClassificazione = [
            { id: "class01", val: "POSSIBILE", label: `${path}.opzioniClassificazione.possibile` },
            { id: "class02", val: "PROBABILE", label: `${path}.opzioniClassificazione.probabile` },
            { id: "class03", val: "CONFERMATO", label: `${path}.opzioniClassificazione.confermato` }
        ];

        const opzioniWestNile = [
            { id: "wn01", val: "NEUROINVASIVA", label: `${path}.opzioniWestNile.neuroinvasiva` },
            { id: "wn02", val: "FEBBRE",         label: `${path}.opzioniWestNile.febbre` },
            { id: "wn03", val: "SINTOMATICO",    label: `${path}.opzioniWestNile.sintomatico` },
            { id: "wn04", val: "ASINTOMATICO",   label: `${path}.opzioniWestNile.asintomatico` },
            { id: "wn05", val: "DONATORE",       label: `${path}.opzioniWestNile.donatore` }
        ];

        const westNileAbilitato = this.isWestNileAbilitato();
        const malattiaNames = { "0664": "West Nile ", "064": "Usutu " };
        const malattiaPrefix = westNileAbilitato ? `${malattiaNames[this.props.malattiacodice]}` : "";

        return (
            <div className={"container"}>
                <div style={{marginTop: "10px"}}/>

                {/* SEZIONE CASO */}
                <div className={"row"} style={{marginTop: "20px"}}>
                    <div className={"col-lg-4"}>
                        <p style={{fontWeight: "600"}}>
                            {t(`${path}.labelCaso`)} <span className={styles.mandatoryColor}>*</span>
                        </p>
                    </div>
                    <div className={"col-lg-7"}>
                        {opzioniCaso.map(opt => (
                            <RadioButton
                                key={opt.id} id={opt.id} name={"caso"}
                                label={t(opt.label)} value={opt.val}
                                newRadio={true} onClick={this.riceviValore}
                                checked={data.caso === opt.val}
                            />
                        ))}
                    </div>
                </div>

                {/* SEZIONE CLASSIFICAZIONE */}
                <div className={"row"} style={{marginTop: "25px"}}>
                    <div className={"col-lg-4"}>
                        <p style={{fontWeight: "600"}}>
                            {t(`${path}.labelClassificazione`)} <span className={styles.mandatoryColor}>*</span>
                        </p>
                    </div>
                    <div className={`col-lg-7 d-flex`}>
                        {opzioniClassificazione.map(opt => (
                            <div key={opt.id} style={{marginRight: "20px"}}>
                                <RadioButton
                                    id={opt.id} name={"classificazione"}
                                    label={t(opt.label)} value={opt.val}
                                    newRadio={true}
                                    onClick={this.riceviValore}
                                    checked={data.classificazione === opt.val}
                                    disabled={true}
                                />
                            </div>
                        ))}
                    </div>
                </div>

                {/* SEZIONE WEST NILE / USUTU */}
                {westNileAbilitato && (
                    <div className={"row"} style={{marginTop: "25px"}}>
                        <div className={"col-lg-4"}>
                            <p style={{fontWeight: "600"}}>
                                {t(`${path}.labelWestNile`)}
                                <span className={styles.mandatoryColor}> *</span>
                            </p>
                        </div>
                        <div className={`col-lg-7`}>
                            {opzioniWestNile.map(opt => (
                                <RadioButton
                                    key={opt.id} id={opt.id} name={"casoWestNile"}
                                    label={`${malattiaPrefix}${t(opt.label)}`} value={opt.val}
                                    newRadio={true} onClick={this.riceviValore}
                                    checked={data.casoWestNile === opt.val}
                                    disabled={true}
                                />
                            ))}
                        </div>
                    </div>
                )}

                {/* NOTE */}
                <div className={"row"} style={{marginTop: "25px"}}>
                    <div className={"col-lg-4"}>
                        <p style={{fontWeight: "600"}}>{t(`${path}.labelNote`)}</p>
                    </div>
                    <div className={"col-lg-8"}>
                        <Input
                            type={"textarea"}
                            field={"note"}
                            placeholder={t(`${path}.labelNote`)}
                            value={data.note}
                            onChange={this.riceviValore}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation('common')(classificazioneDelCaso);